@file:OptIn(InternalResourceApi::class)

package mapl.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/mapl.composeapp.generated.resources/"

@delegate:ResourceContentHash(-509_618_496)
internal val Res.string.add_round_flek: StringResource by lazy {
      StringResource("string:add_round_flek", "add_round_flek", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 10, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 30),
      ))
    }

@delegate:ResourceContentHash(1_663_746_891)
internal val Res.string.add_round_game: StringResource by lazy {
      StringResource("string:add_round_game", "add_round_game", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 41, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 41, 30),
      ))
    }

@delegate:ResourceContentHash(1_640_719_317)
internal val Res.string.add_round_no_caller_to_pot: StringResource by lazy {
      StringResource("string:add_round_no_caller_to_pot", "add_round_no_caller_to_pot", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 72, 90),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 72, 78),
      ))
    }

@delegate:ResourceContentHash(1_197_482_174)
internal val Res.string.add_round_playing: StringResource by lazy {
      StringResource("string:add_round_playing", "add_round_playing", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 163, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 151, 33),
      ))
    }

@delegate:ResourceContentHash(275_044_733)
internal val Res.string.add_round_suit: StringResource by lazy {
      StringResource("string:add_round_suit", "add_round_suit", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 197, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185, 30),
      ))
    }

@delegate:ResourceContentHash(1_257_313_231)
internal val Res.string.add_round_title: StringResource by lazy {
      StringResource("string:add_round_title", "add_round_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 228, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 216, 35),
      ))
    }

@delegate:ResourceContentHash(-909_011_360)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 268, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 252, 24),
      ))
    }

@delegate:ResourceContentHash(1_891_552_268)
internal val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 293, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 277, 20),
      ))
    }

@delegate:ResourceContentHash(-228_377_896)
internal val Res.string.cancel: StringResource by lazy {
      StringResource("string:cancel", "cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 314, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 298, 22),
      ))
    }

@delegate:ResourceContentHash(56_165_098)
internal val Res.string.close: StringResource by lazy {
      StringResource("string:close", "close", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 341, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321, 21),
      ))
    }

@delegate:ResourceContentHash(1_382_802_613)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 367, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 343, 27),
      ))
    }

@delegate:ResourceContentHash(-415_680_828)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 395, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 371, 22),
      ))
    }

@delegate:ResourceContentHash(-325_183_671)
internal val Res.string.end: StringResource by lazy {
      StringResource("string:end", "end", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 418, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 394, 15),
      ))
    }

@delegate:ResourceContentHash(-290_031_616)
internal val Res.string.home_join: StringResource by lazy {
      StringResource("string:home_join", "home_join", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 550, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 502, 25),
      ))
    }

@delegate:ResourceContentHash(-1_471_015_000)
internal val Res.string.home_join_game: StringResource by lazy {
      StringResource("string:home_join_game", "home_join_game", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 442, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 410, 38),
      ))
    }

@delegate:ResourceContentHash(1_615_477_509)
internal val Res.string.home_join_manual: StringResource by lazy {
      StringResource("string:home_join_manual", "home_join_manual", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 493, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 449, 52),
      ))
    }

@delegate:ResourceContentHash(-1_319_385_012)
internal val Res.string.home_language_czech: StringResource by lazy {
      StringResource("string:home_language_czech", "home_language_czech", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 580, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 528, 35),
      ))
    }

@delegate:ResourceContentHash(1_899_283_463)
internal val Res.string.home_language_english: StringResource by lazy {
      StringResource("string:home_language_english", "home_language_english", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 620, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 564, 41),
      ))
    }

@delegate:ResourceContentHash(-1_835_352_195)
internal val Res.string.home_no_sessions: StringResource by lazy {
      StringResource("string:home_no_sessions", "home_no_sessions", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 666, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 606, 72),
      ))
    }

@delegate:ResourceContentHash(-1_002_583_264)
internal val Res.string.home_pending_session_name: StringResource by lazy {
      StringResource("string:home_pending_session_name", "home_pending_session_name", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 743, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 679, 41),
      ))
    }

@delegate:ResourceContentHash(-1_070_734_954)
internal val Res.string.home_pending_session_subtitle: StringResource by lazy {
      StringResource("string:home_pending_session_subtitle", "home_pending_session_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 785, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 721, 81),
      ))
    }

@delegate:ResourceContentHash(744_273_617)
internal val Res.string.home_players_count: StringResource by lazy {
      StringResource("string:home_players_count", "home_players_count", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 871, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 803, 58),
      ))
    }

@delegate:ResourceContentHash(1_651_766_314)
internal val Res.string.home_players_rounds_count: StringResource by lazy {
      StringResource("string:home_players_rounds_count", "home_players_rounds_count", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 934, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 862, 85),
      ))
    }

@delegate:ResourceContentHash(-378_095_897)
internal val Res.string.home_rules_title: StringResource by lazy {
      StringResource("string:home_rules_title", "home_rules_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1020, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 948, 40),
      ))
    }

@delegate:ResourceContentHash(1_082_181_120)
internal val Res.string.home_session_deleted: StringResource by lazy {
      StringResource("string:home_session_deleted", "home_session_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1061, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 989, 44),
      ))
    }

@delegate:ResourceContentHash(-266_912_159)
internal val Res.string.home_session_id: StringResource by lazy {
      StringResource("string:home_session_id", "home_session_id", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1110, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1034, 35),
      ))
    }

@delegate:ResourceContentHash(179_766_161)
internal val Res.string.home_session_not_found: StringResource by lazy {
      StringResource("string:home_session_not_found", "home_session_not_found", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1146, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1070, 50),
      ))
    }

@delegate:ResourceContentHash(151_558_640)
internal val Res.string.home_sessions_deleted_count: StringResource by lazy {
      StringResource("string:home_sessions_deleted_count", "home_sessions_deleted_count", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1201, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1121, 59),
      ))
    }

@delegate:ResourceContentHash(87_501_169)
internal val Res.string.home_status_active: StringResource by lazy {
      StringResource("string:home_status_active", "home_status_active", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1269, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1181, 34),
      ))
    }

@delegate:ResourceContentHash(-978_509_747)
internal val Res.string.home_status_finished: StringResource by lazy {
      StringResource("string:home_status_finished", "home_status_finished", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1308, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1216, 40),
      ))
    }

@delegate:ResourceContentHash(1_557_971_146)
internal val Res.string.home_status_waiting_sync: StringResource by lazy {
      StringResource("string:home_status_waiting_sync", "home_status_waiting_sync", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1345, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1257, 56),
      ))
    }

@delegate:ResourceContentHash(-909_011_360)
internal val Res.string.home_title: StringResource by lazy {
      StringResource("string:home_title", "home_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1410, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1314, 26),
      ))
    }

@delegate:ResourceContentHash(75_005_088)
internal val Res.string.minus: StringResource by lazy {
      StringResource("string:minus", "minus", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1437, 17),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1341, 17),
      ))
    }

@delegate:ResourceContentHash(162_938_213)
internal val Res.string.new_player_name: StringResource by lazy {
      StringResource("string:new_player_name", "new_player_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1359, 39),
      ))
    }

@delegate:ResourceContentHash(-866_493_590)
internal val Res.string.new_session_add_player: StringResource by lazy {
      StringResource("string:new_session_add_player", "new_session_add_player", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1455, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1399, 46),
      ))
    }

@delegate:ResourceContentHash(-938_270_759)
internal val Res.string.new_session_bet: StringResource by lazy {
      StringResource("string:new_session_bet", "new_session_bet", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1506, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1446, 35),
      ))
    }

@delegate:ResourceContentHash(-669_444_716)
internal val Res.string.new_session_create: StringResource by lazy {
      StringResource("string:new_session_create", "new_session_create", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1554, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1482, 42),
      ))
    }

@delegate:ResourceContentHash(-723_200_750)
internal val Res.string.new_session_name: StringResource by lazy {
      StringResource("string:new_session_name", "new_session_name", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1605, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1525, 36),
      ))
    }

@delegate:ResourceContentHash(582_221_126)
internal val Res.string.new_session_players: StringResource by lazy {
      StringResource("string:new_session_players", "new_session_players", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1650, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1562, 63),
      ))
    }

@delegate:ResourceContentHash(-1_333_600_414)
internal val Res.string.new_session_pot_toggle: StringResource by lazy {
      StringResource("string:new_session_pot_toggle", "new_session_pot_toggle", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1710, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1626, 50),
      ))
    }

@delegate:ResourceContentHash(2_116_468_808)
internal val Res.string.new_session_title: StringResource by lazy {
      StringResource("string:new_session_title", "new_session_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1761, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1677, 37),
      ))
    }

@delegate:ResourceContentHash(75_220_352)
internal val Res.string.plus: StringResource by lazy {
      StringResource("string:plus", "plus", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1803, 16),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1715, 16),
      ))
    }

@delegate:ResourceContentHash(-802_041_461)
internal val Res.string.qr_scanner_web_error: StringResource by lazy {
      StringResource("string:qr_scanner_web_error", "qr_scanner_web_error", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1820, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1732, 112),
      ))
    }

@delegate:ResourceContentHash(-337_237_198)
internal val Res.string.qr_scanner_web_permission_denied: StringResource by lazy {
      StringResource("string:qr_scanner_web_permission_denied", "qr_scanner_web_permission_denied", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 1941, 140),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1845, 128),
      ))
    }

@delegate:ResourceContentHash(-971_992_384)
internal val Res.string.qr_scanner_web_scanning: StringResource by lazy {
      StringResource("string:qr_scanner_web_scanning", "qr_scanner_web_scanning", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2082, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1974, 107),
      ))
    }

@delegate:ResourceContentHash(-774_701_791)
internal val Res.string.qr_scanner_web_starting: StringResource by lazy {
      StringResource("string:qr_scanner_web_starting", "qr_scanner_web_starting", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2170, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2082, 67),
      ))
    }

@delegate:ResourceContentHash(-1_248_988_401)
internal val Res.string.qr_scanner_web_unsupported: StringResource by lazy {
      StringResource("string:qr_scanner_web_unsupported", "qr_scanner_web_unsupported", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2242, 162),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2150, 146),
      ))
    }

@delegate:ResourceContentHash(-1_691_410_716)
internal val Res.string.reactivate: StringResource by lazy {
      StringResource("string:reactivate", "reactivate", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2405, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2297, 34),
      ))
    }

@delegate:ResourceContentHash(98_345_856)
internal val Res.string.remove: StringResource by lazy {
      StringResource("string:remove", "remove", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2436, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2332, 18),
      ))
    }

@delegate:ResourceContentHash(-1_408_951_452)
internal val Res.string.rules_app_version: StringResource by lazy {
      StringResource("string:rules_app_version", "rules_app_version", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2455, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2351, 57),
      ))
    }

@delegate:ResourceContentHash(-615_013_298)
internal val Res.string.rules_bets_body: StringResource by lazy {
      StringResource("string:rules_bets_body", "rules_bets_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2517, 375),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2409, 331),
      ))
    }

@delegate:ResourceContentHash(-1_889_842_459)
internal val Res.string.rules_bets_title: StringResource by lazy {
      StringResource("string:rules_bets_title", "rules_bets_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2893, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2741, 36),
      ))
    }

@delegate:ResourceContentHash(-711_541_128)
internal val Res.string.rules_betting_body: StringResource by lazy {
      StringResource("string:rules_betting_body", "rules_betting_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 2930, 302),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2778, 250),
      ))
    }

@delegate:ResourceContentHash(-1_982_171_487)
internal val Res.string.rules_betting_title: StringResource by lazy {
      StringResource("string:rules_betting_title", "rules_betting_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 3233, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3029, 67),
      ))
    }

@delegate:ResourceContentHash(-2_128_141_099)
internal val Res.string.rules_bidding_body: StringResource by lazy {
      StringResource("string:rules_bidding_body", "rules_bidding_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 3309, 690),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3097, 666),
      ))
    }

@delegate:ResourceContentHash(-622_180_747)
internal val Res.string.rules_bidding_title: StringResource by lazy {
      StringResource("string:rules_bidding_title", "rules_bidding_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 4000, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3764, 71),
      ))
    }

@delegate:ResourceContentHash(-452_000_055)
internal val Res.string.rules_intro: StringResource by lazy {
      StringResource("string:rules_intro", "rules_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 4068, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3836, 143),
      ))
    }

@delegate:ResourceContentHash(617_160_082)
internal val Res.string.rules_pot_body: StringResource by lazy {
      StringResource("string:rules_pot_body", "rules_pot_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 4220, 526),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3980, 474),
      ))
    }

@delegate:ResourceContentHash(1_002_815_493)
internal val Res.string.rules_pot_title: StringResource by lazy {
      StringResource("string:rules_pot_title", "rules_pot_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 4747, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4455, 31),
      ))
    }

@delegate:ResourceContentHash(518_657_963)
internal val Res.string.rules_scoring_body: StringResource by lazy {
      StringResource("string:rules_scoring_body", "rules_scoring_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 4783, 446),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4487, 458),
      ))
    }

@delegate:ResourceContentHash(858_918_792)
internal val Res.string.rules_scoring_title: StringResource by lazy {
      StringResource("string:rules_scoring_title", "rules_scoring_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 5230, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4946, 43),
      ))
    }

@delegate:ResourceContentHash(1_150_614_482)
internal val Res.string.rules_setup_body: StringResource by lazy {
      StringResource("string:rules_setup_body", "rules_setup_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 5286, 444),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4990, 340),
      ))
    }

@delegate:ResourceContentHash(-1_226_201_670)
internal val Res.string.rules_setup_title: StringResource by lazy {
      StringResource("string:rules_setup_title", "rules_setup_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 5731, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5331, 57),
      ))
    }

@delegate:ResourceContentHash(1_676_867_540)
internal val Res.string.rules_summary_title: StringResource by lazy {
      StringResource("string:rules_summary_title", "rules_summary_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 5781, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5389, 71),
      ))
    }

@delegate:ResourceContentHash(1_960_197_151)
internal val Res.string.rules_tricks_body: StringResource by lazy {
      StringResource("string:rules_tricks_body", "rules_tricks_body", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 5865, 449),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5461, 397),
      ))
    }

@delegate:ResourceContentHash(757_186_601)
internal val Res.string.rules_tricks_title: StringResource by lazy {
      StringResource("string:rules_tricks_title", "rules_tricks_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6315, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5859, 50),
      ))
    }

@delegate:ResourceContentHash(1_257_313_231)
internal val Res.string.session_add_round: StringResource by lazy {
      StringResource("string:session_add_round", "session_add_round", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6366, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5910, 37),
      ))
    }

@delegate:ResourceContentHash(591_391_102)
internal val Res.string.session_bet_label: StringResource by lazy {
      StringResource("string:session_bet_label", "session_bet_label", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6408, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5948, 37),
      ))
    }

@delegate:ResourceContentHash(212_236_809)
internal val Res.string.session_change_bet: StringResource by lazy {
      StringResource("string:session_change_bet", "session_change_bet", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6450, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5986, 42),
      ))
    }

@delegate:ResourceContentHash(83_021_529)
internal val Res.string.session_end_confirm: StringResource by lazy {
      StringResource("string:session_end_confirm", "session_end_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6570, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6106, 75),
      ))
    }

@delegate:ResourceContentHash(-1_852_035_589)
internal val Res.string.session_end_confirm_name: StringResource by lazy {
      StringResource("string:session_end_confirm_name", "session_end_confirm_name", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6497, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6029, 76),
      ))
    }

@delegate:ResourceContentHash(1_556_061_664)
internal val Res.string.session_end_title: StringResource by lazy {
      StringResource("string:session_end_title", "session_end_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6646, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6182, 37),
      ))
    }

@delegate:ResourceContentHash(1_521_846_727)
internal val Res.string.session_no_rounds: StringResource by lazy {
      StringResource("string:session_no_rounds", "session_no_rounds", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6692, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6220, 45),
      ))
    }

@delegate:ResourceContentHash(497_400_842)
internal val Res.string.session_pot_label: StringResource by lazy {
      StringResource("string:session_pot_label", "session_pot_label", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6746, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6266, 37),
      ))
    }

@delegate:ResourceContentHash(83_750_560)
internal val Res.string.session_qr: StringResource by lazy {
      StringResource("string:session_qr", "session_qr", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6788, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6304, 22),
      ))
    }

@delegate:ResourceContentHash(-1_492_254_358)
internal val Res.string.session_round_deleted: StringResource by lazy {
      StringResource("string:session_round_deleted", "session_round_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6811, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6327, 49),
      ))
    }

@delegate:ResourceContentHash(240_556_624)
internal val Res.string.session_round_lost: StringResource by lazy {
      StringResource("string:session_round_lost", "session_round_lost", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6861, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6377, 34),
      ))
    }

@delegate:ResourceContentHash(105_304_669)
internal val Res.string.session_round_no_call: StringResource by lazy {
      StringResource("string:session_round_no_call", "session_round_no_call", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6900, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6412, 41),
      ))
    }

@delegate:ResourceContentHash(-1_392_572_806)
internal val Res.string.session_round_pot_added: StringResource by lazy {
      StringResource("string:session_round_pot_added", "session_round_pot_added", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 6950, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6454, 59),
      ))
    }

@delegate:ResourceContentHash(1_867_802_714)
internal val Res.string.session_round_won: StringResource by lazy {
      StringResource("string:session_round_won", "session_round_won", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 7018, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6514, 29),
      ))
    }

@delegate:ResourceContentHash(-2_043_482_995)
internal val Res.string.session_rounds_count: StringResource by lazy {
      StringResource("string:session_rounds_count", "session_rounds_count", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 7052, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6544, 44),
      ))
    }

@delegate:ResourceContentHash(-1_285_844_625)
internal val Res.string.session_share: StringResource by lazy {
      StringResource("string:session_share", "session_share", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 7101, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6589, 37),
      ))
    }

@delegate:ResourceContentHash(1_851_125_885)
internal val Res.string.session_title: StringResource by lazy {
      StringResource("string:session_title", "session_title", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 7143, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6627, 29),
      ))
    }

@delegate:ResourceContentHash(-815_284_702)
internal val Res.string.undo: StringResource by lazy {
      StringResource("string:undo", "undo", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 7173, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6657, 20),
      ))
    }

@delegate:ResourceContentHash(79_986_912)
internal val Res.string.unknown: StringResource by lazy {
      StringResource("string:unknown", "unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("cs"), ), "${MD}values-cs/strings.commonMain.cvr", 7194, 19),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6678, 19),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_round_flek", Res.string.add_round_flek)
  map.put("add_round_game", Res.string.add_round_game)
  map.put("add_round_no_caller_to_pot", Res.string.add_round_no_caller_to_pot)
  map.put("add_round_playing", Res.string.add_round_playing)
  map.put("add_round_suit", Res.string.add_round_suit)
  map.put("add_round_title", Res.string.add_round_title)
  map.put("app_name", Res.string.app_name)
  map.put("back", Res.string.back)
  map.put("cancel", Res.string.cancel)
  map.put("close", Res.string.close)
  map.put("confirm", Res.string.confirm)
  map.put("delete", Res.string.delete)
  map.put("end", Res.string.end)
  map.put("home_join", Res.string.home_join)
  map.put("home_join_game", Res.string.home_join_game)
  map.put("home_join_manual", Res.string.home_join_manual)
  map.put("home_language_czech", Res.string.home_language_czech)
  map.put("home_language_english", Res.string.home_language_english)
  map.put("home_no_sessions", Res.string.home_no_sessions)
  map.put("home_pending_session_name", Res.string.home_pending_session_name)
  map.put("home_pending_session_subtitle", Res.string.home_pending_session_subtitle)
  map.put("home_players_count", Res.string.home_players_count)
  map.put("home_players_rounds_count", Res.string.home_players_rounds_count)
  map.put("home_rules_title", Res.string.home_rules_title)
  map.put("home_session_deleted", Res.string.home_session_deleted)
  map.put("home_session_id", Res.string.home_session_id)
  map.put("home_session_not_found", Res.string.home_session_not_found)
  map.put("home_sessions_deleted_count", Res.string.home_sessions_deleted_count)
  map.put("home_status_active", Res.string.home_status_active)
  map.put("home_status_finished", Res.string.home_status_finished)
  map.put("home_status_waiting_sync", Res.string.home_status_waiting_sync)
  map.put("home_title", Res.string.home_title)
  map.put("minus", Res.string.minus)
  map.put("new_player_name", Res.string.new_player_name)
  map.put("new_session_add_player", Res.string.new_session_add_player)
  map.put("new_session_bet", Res.string.new_session_bet)
  map.put("new_session_create", Res.string.new_session_create)
  map.put("new_session_name", Res.string.new_session_name)
  map.put("new_session_players", Res.string.new_session_players)
  map.put("new_session_pot_toggle", Res.string.new_session_pot_toggle)
  map.put("new_session_title", Res.string.new_session_title)
  map.put("plus", Res.string.plus)
  map.put("qr_scanner_web_error", Res.string.qr_scanner_web_error)
  map.put("qr_scanner_web_permission_denied", Res.string.qr_scanner_web_permission_denied)
  map.put("qr_scanner_web_scanning", Res.string.qr_scanner_web_scanning)
  map.put("qr_scanner_web_starting", Res.string.qr_scanner_web_starting)
  map.put("qr_scanner_web_unsupported", Res.string.qr_scanner_web_unsupported)
  map.put("reactivate", Res.string.reactivate)
  map.put("remove", Res.string.remove)
  map.put("rules_app_version", Res.string.rules_app_version)
  map.put("rules_bets_body", Res.string.rules_bets_body)
  map.put("rules_bets_title", Res.string.rules_bets_title)
  map.put("rules_betting_body", Res.string.rules_betting_body)
  map.put("rules_betting_title", Res.string.rules_betting_title)
  map.put("rules_bidding_body", Res.string.rules_bidding_body)
  map.put("rules_bidding_title", Res.string.rules_bidding_title)
  map.put("rules_intro", Res.string.rules_intro)
  map.put("rules_pot_body", Res.string.rules_pot_body)
  map.put("rules_pot_title", Res.string.rules_pot_title)
  map.put("rules_scoring_body", Res.string.rules_scoring_body)
  map.put("rules_scoring_title", Res.string.rules_scoring_title)
  map.put("rules_setup_body", Res.string.rules_setup_body)
  map.put("rules_setup_title", Res.string.rules_setup_title)
  map.put("rules_summary_title", Res.string.rules_summary_title)
  map.put("rules_tricks_body", Res.string.rules_tricks_body)
  map.put("rules_tricks_title", Res.string.rules_tricks_title)
  map.put("session_add_round", Res.string.session_add_round)
  map.put("session_bet_label", Res.string.session_bet_label)
  map.put("session_change_bet", Res.string.session_change_bet)
  map.put("session_end_confirm", Res.string.session_end_confirm)
  map.put("session_end_confirm_name", Res.string.session_end_confirm_name)
  map.put("session_end_title", Res.string.session_end_title)
  map.put("session_no_rounds", Res.string.session_no_rounds)
  map.put("session_pot_label", Res.string.session_pot_label)
  map.put("session_qr", Res.string.session_qr)
  map.put("session_round_deleted", Res.string.session_round_deleted)
  map.put("session_round_lost", Res.string.session_round_lost)
  map.put("session_round_no_call", Res.string.session_round_no_call)
  map.put("session_round_pot_added", Res.string.session_round_pot_added)
  map.put("session_round_won", Res.string.session_round_won)
  map.put("session_rounds_count", Res.string.session_rounds_count)
  map.put("session_share", Res.string.session_share)
  map.put("session_title", Res.string.session_title)
  map.put("undo", Res.string.undo)
  map.put("unknown", Res.string.unknown)
}
